import * as React from 'react';
import classnames from 'classnames';

import Entity from 'components/entity/Entity';
import EntityName from 'components/entity/entity-name/EntityName';
import EntityAvatar from 'components/entity/entity-avatar/EntityAvatar';

import './entity-resources.scss';

import type { Entity as EntityType } from 'types';

type Props = {
  entity: EntityType | undefined | null,
  children: React.ReactNode,
  withPaddedChildren?: boolean
};

const EntityResources = (
  {
    entity,
    children,
    withPaddedChildren
  }: Props
): JSX.Element => {
  const contentClassName = classnames('entity-resources__content', {
    'entity-resources__content--padded': withPaddedChildren
  });

  return (
    <section className="entity-resources">
      {
        entity &&
        <div className="entity-resources__header">
          <Entity>
            <EntityAvatar
              entity={entity}
              bordered
              size="medium"
            />
            <EntityName
              entity={entity}
              size="inherit"
            />
          </Entity>
        </div>
      }
      <div className={contentClassName}>
        {children}
      </div>
    </section>
  );
};

export default EntityResources;
